<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="130">
       
        <Row>
            <Col span="24">
                <FormItem label="报告名称:" prop="name" :class="{requireStar:true}" >
                  <Input v-model="formValidate.name"  ></Input>
                </FormItem>
            </Col>
        </Row>
         <Row >
            <Col span="24">
                  <FormItem label="报告时间段:" prop="startDate">
                     <DatePicker type="date" placeholder="开始时间" format="yyyy-MM-dd"
                            v-model="formValidate.startDate" @on-change="formValidate.startDate=$event" ></DatePicker>——
                          <DatePicker type="date" placeholder="结束时间"
                              v-model="formValidate.endDate" format="yyyy-MM-dd"  @on-change="formValidate.endDate=$event" ></DatePicker>
                        </FormItem>
            </Col>
        </Row>
         <Row >
            <Col span="24">
                  <FormItem label="选择报告生成内容:" prop="content">
                      <CheckboxGroup v-model="formValidate.content">
                        <Checkbox label="旅游"></Checkbox>
                        <Checkbox label="演出"></Checkbox>
                        <Checkbox label="文化"></Checkbox>
                        <Checkbox label="舆情"></Checkbox>
                    </CheckboxGroup>
                  </FormItem>
            </Col>
        </Row>
    
        
       
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import moment from 'moment'
  export default {
    components:{
    },
    data() {
      return {
        userForm: false,
        title:'',
      
        formValidate: {
          _id: '',
          name: '',
          startDate: '',
          endDate: '',
          content:[],
          tag:''
        },
        ruleValidate: {
          name: [{
            required: true,
            message: '报告名称不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
      },  
    
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            if(this.formValidate.content==''){
                alert("请选择报告生成内容")
                return
            }
            let url =  'api/report/stat_word_report' 
            let myData = {
              reportName: this.formValidate.name,
              startTime:moment(this.formValidate.startDate).format('YYYY-MM-DD'),
				  	  endTime:moment(this.formValidate.endDate).format('YYYY-MM-DD'),
              category: this.formValidate.content,
              
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
             if (response.data.code == 200) {
                let _id=response.data.data._id
                 this.userForm = false;
                this.$parent.reportSeeForm(this.formValidate.name,_id);
                this.$parent.loadPage();
                this.$Message.success(response.data.msg);
                
              } else {
                 this.$Message.error(response.data.msg);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/createReport/CreateReportEdit.vue